export default {
  name: 'BillingCommissionsCard',
  components: { },
  props: ['title', 'cash', 'description'],
  data () {
    return {
    }
  },
  methods: {
  },
  mounted () {
  }
}
